<p-dialog
  [(visible)]="dialogDisplay"
  [modal]="true"
  [style]="{ width: '40vw' }"
  class="error-dialog"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  icon="pi pi-exclamation-triangle"
>
  <ng-template class="p-dialog-title" pTemplate="header">
    <strong>Error</strong>
  </ng-template>
  <div class="dialog-body-container">
    <p class="p-m-0">No hay suficientes datos.</p>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      icon=" pi pi-check"
      (click)="dialogDisplay = false"
      label="Ok"
      styleClass="p-button-text"
    ></p-button>
  </ng-template>
</p-dialog>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  name="loadingHistorial"
  size="medium"
  color="#fff"
  type="ball-rotate"
  [fullScreen]="true"
  ><p style="color: white">Cargando Historial...</p></ngx-spinner
>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  name="loadingHistorialForm"
  size="medium"
  color="#fff"
  type="ball-rotate"
  [fullScreen]="false"
  ><p style="color: white">Cargando información...</p></ngx-spinner
>

<div *ngIf="historialService.modalActive">
  <!-- <app-panel-historial-recorrido-modal></app-panel-historial-recorrido-modal> -->
  <app-panel-historial-grafico></app-panel-historial-grafico>
</div>

<div
  id="panel_historial"
  class="modal-body p-fluid p-0 overflow-auto"
  style="position: relative"
>
  <div class="panel-izq-container">
    <div class="panel-izq-form">
      <div *ngIf="soloParaMi" class="modal-footer">
        <div class="row w-100 justify-content-around">
          <div class="col-5">
            <button
              type="button"
              (click)="clickEnviarCorreoExcel()"
              class="btn btn-success not-cancel w-100"
            >
              Enviar Correo EXCEL
            </button>
          </div>
          <div class="col-5">
            <button
              type="button"
              (click)="clickEliminarHistorial()"
              class="btn btn-success w-100"
            >
              Ocultar
            </button>
          </div>
        </div>
      </div>

      <div class="gl-middleline gl-permanent-middleline gl-row-underline">
        <div class="row">
          <div class="col p-field w-25">
            <div class="row">
              <div class="col-12">
                <label>{{'HISTORY.FIELDS.VEHICLE' | translate}}:</label>
              </div>


              <div class="col-12">
                <p-dropdown
                  [filter]="true"
                  [options]="cars"
                  optionLabel="nombre"
                  optionValue="imei"
                  [(ngModel)]="form.selectedCar"
                  [showClear]="true"
                  [appendTo]="'body'"
                  placeholder="Seleccione el vehículo..."
                ></p-dropdown>
              </div>


            </div>
          </div>

          <div class="col p-field">
            <div class="row">
              <div class="col-12">
                <label>{{'HISTORY.FIELDS.ROUTE_COLOR' | translate}}:</label>
              </div>
              <div class="col-12 d-flex">
                <input
                  type="color"
                  class="form-control form-control-color form-control-color-gl flex-grow-1"
                  id="colorRuta"
                  [(ngModel)]="form.colorHistorial"
                  (change)="changeColorHistorial()"
                  title="Elige un color"
                />
                <label
                  role="button"
                  class="p-dropdown-trigger flex-none d-flex align-items-center custom-chevron"
                  for="colorRuta"
                >
                  <span
                    class="p-dropdown-trigger-icon pi pi-chevron-down"
                  ></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gl-row-underline">
        <div class="col-12">
          <label>{{'FIELDS.FILTER_BY' | translate}}:</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [options]="availableOptionsDay"
            optionLabel="name"
            optionValue="id"
            [(ngModel)]="form.selectedRango"
            [showClear]="false"
            [appendTo]="'body'"
            (onChange)="changeRangoFechas()"
          ></p-dropdown>
        </div>
      </div>

      <div class="gl-middleline gl-permanent-middleline gl-row-underline">
        <div class="row">
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.START_DATE' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-calendar
                [(ngModel)]="form.pngFechaIni"
                dateFormat="yy-mm-dd"
                [appendTo]="'body'"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="2000:2040"
                [showIcon]="true"
                [maxDate]="form.pngFechaFin"
              ></p-calendar>
            </div>
          </div>
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.START_TIME' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-calendar
                [(ngModel)]="form.pngHoraIni2"
                [timeOnly]="true"
                [appendTo]="'body'"
                [showIcon]="true"
                icon="pi pi-clock"
              ></p-calendar>
            </div>
          </div>
        </div>
      </div>

      <div class="gl-middleline gl-permanent-middleline gl-row-underline">
        <div class="row">
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.END_DATE' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-calendar
                [(ngModel)]="form.pngFechaFin"
                dateFormat="yy-mm-dd"
                [appendTo]="'body'"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="2000:2040"
                [showIcon]="true"
                [minDate]="form.pngFechaIni"
              ></p-calendar>
            </div>
          </div>
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.END_TIME' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-calendar
                [(ngModel)]="form.pngHoraFin2"
                [timeOnly]="true"
                [appendTo]="'body'"
                [showIcon]="true"
                icon="pi pi-clock"
              ></p-calendar>
            </div>
          </div>
        </div>
      </div>

      <div class="gl-middleline gl-permanent-middleline gl-row-underline">
        <div class="row">
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.STOPS' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-dropdown
                [options]="booleanOptions"
                [(ngModel)]="form.chckParada"
                (onChange)="changeShowingParadasHistorial()"
                optionLabel="label"
                optionValue="value"
                [appendTo]="'body'"
              ></p-dropdown>
            </div>
          </div>
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.DURATION' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-dropdown
                [options]="availableOptionsTempoParada"
                optionLabel="name"
                optionValue="id"
                [(ngModel)]="form.duracionParada"
                [showClear]="false"
                [appendTo]="'body'"
              >
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="gl-middleline gl-permanent-middleline gl-row-underline">
        <div class="row">
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.FRAMES' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-dropdown
                [options]="booleanOptions"
                [(ngModel)]="form.chckTrama"
                (onChange)="
                  changeShowingTramas(); changeShowingTramasFechaVelocidad()
                "
                optionLabel="label"
                optionValue="value"
                [appendTo]="'body'"
              ></p-dropdown>
            </div>
          </div>
          <div class="col p-field">
            <div class="col-12">
              <label>{{'FIELDS.SPEED_AND_DATE' | translate}}:</label>
            </div>
            <div class="col-12">
              <p-dropdown
                [options]="booleanOptions"
                [(ngModel)]="form.chckTramaFechaVelocidad"
                [disabled]="!form.chckTrama"
                (onChange)="changeShowingTramasFechaVelocidad()"
                optionLabel="label"
                optionValue="value"
                [appendTo]="'body'"
              ></p-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="gl-row-underline">
          <div class="col-12">
            <label>{{'FIELDS.EVENTS' | translate}}:</label>
          </div>
          <div class="col-12">
            <p-multiSelect
              [options]="eventList"
              [group]="true"
              [(ngModel)]="selectedEvents"
              optionLabel="name"
              defaultLabel="Sin eventos seleccionados"
              [selectedItemsLabel]="'{0} eventos seleccionados'"
              [showToggleAll]="false"
              scrollHeight="250px"
              (onChange)="changeShowingEventos()"
              [appendTo]="'body'"
            >
              <ng-template let-group pTemplate="group">
                <div class="p-d-flex p-ai-center">
                  <span>{{ group.label }}</span>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>
        <div
          style="padding: 0px 0.3rem; margin-top: 0.25rem; text-align: right"
        >
          <label>
            <p-checkbox
              [(ngModel)]="chkAllEvents"
              [binary]="true"
              inputId="binary"
              (onChange)="onChkAllEvents(); changeShowingEventos()"
            ></p-checkbox>
            {{'GENERAL.ALL' | translate}}
          </label>
        </div>
      </div>

      <div class="gl-row-underline">
        <div class="col-12">
          <label>{{'FIELDS.CHART' | translate}}:</label>
        </div>
        <div class="col-12">
          <p-dropdown
            [options]="booleanOptions"
            [(ngModel)]="form.chckGrafico"
            (onChange)="changeShowingGrafico()"
            optionLabel="label"
            optionValue="value"
            [appendTo]="'body'"
          ></p-dropdown>
        </div>
      </div>


      <div class="row justify-content-center mt-4 panel-izq-container-footer">
        <div class="col-6">
          <button
            type="submit"
            class="btn-gl-cancel btn-dark-hover w-100"
            (click)="clickEliminarHistorial()"
            [disabled]="form.selectedCar == null"
          >
            {{'GENERAL.HIDE' | translate}}
          </button>
        </div>
        <div class="col-6">
          <button
            type="button"
            class="btn-gl-save btn-dark-hover w-100"
            id="btnMostrarHistorial"
            ui-sref="alertas-accesorios"
            (click)="clickCargarHistorial()"
            [disabled]="form.selectedCar == null"
          >
            {{'GENERAL.SHOW' | translate}}
          </button>
        </div>
      </div>

    </div>

    <div class="card-body" style="display: none">
    </div>

    <!-- <legend></legend> -->

    <!-- <div class="table-content-component-panel-monitoreo h-auto" *ngIf="isHistorialTableLoaded"> -->
    <div
      class="table-content-component-panel-monitoreo h-auto"
      *ngIf="historialService.arrayRecorridos.length > 0"
    >
      <div class="" style="overflow-y: auto">
        <p-table
          [value]="historialService.arrayRecorridos"
          dataKey="key"
          id="tabla_historial"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 7%"></th>
              <th style="width: 7%"></th>
              <th style="width: 30%">Objeto</th>

              <th class="text-center" style="width: 20%">
                Consumo de Combustible
              </th>

              <th class="text-center" style="width: 20%">Kilometraje</th>
              <th style="width: 9%">
                <!-- <button type="button" pButton  class="p-button-text p-button-rounded p-button-plain" >Eliminar</button> -->
              </th>
              <th style="width: 9%" *ngIf="form.chckGrafico">
                <!-- <button type="button" pButton  class="p-button-text p-button-rounded p-button-plain" >Eliminar</button> -->
              </th>
              <!-- <th pSortableColumn="price">Price <p-sortIcon field="price"></p-sortIcon></th> -->
              <!-- <th pSortableColumn="category">Category <p-sortIcon field="category"></p-sortIcon></th> -->
              <!-- <th pSortableColumn="rating">Reviews <p-sortIcon field="rating"></p-sortIcon></th> -->
              <!-- <th pSortableColumn="inventoryStatus">Status <p-sortIcon field="inventoryStatus"></p-sortIcon></th> -->
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-recorrido
            let-expanded="expanded"
            let-rowIndex="rowIndex"
          >
            <tr>
              <td>
                <button
                  type="button"
                  pButton
                  pRipple
                  [pRowToggler]="recorrido"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="
                    expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
                  "
                ></button>
              </td>
              <td class="text-center">
                <p-checkbox
                  [(ngModel)]="recorrido.mostrarRuta"
                  [binary]="true"
                  inputId="binary"
                  (onChange)="onChkMostrarRuta(rowIndex)"
                ></p-checkbox>
              </td>
              <td>
                {{ recorrido.nombre }} <br />
                {{ recorrido.f_ini }} - <br />
                {{ recorrido.f_fin }}
              </td>

              <td class="text-center">
                {{ recorrido.combustibleTotal }}
              </td>

              <td class="text-center">
                {{ recorrido.kilometrajeTotal }}
              </td>
              <td>
                <button
                  type="button"
                  pButton
                  class="p-button-text p-button-rounded p-button-plain"
                  [title]="'Borrar Recorrido'"
                  (click)="clickEliminar(rowIndex, recorrido.key)"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </td>
              <td *ngIf="form.chckGrafico">
                <button
                  type="button"
                  pButton
                  class="p-button-text p-button-rounded p-button-plain"
                  [title]="'Mostrar Gráfico'"
                  (click)="clickVerGrafico(rowIndex, recorrido.key)"
                >
                  <i class="fa fa-area-chart" aria-hidden="true"></i>
                </button>
              </td>
              <!-- <td>{{product.price | currency:'USD'}}</td> -->
              <!-- <td>{{product.category}}</td> -->
              <!-- <td><p-rating [ngModel]="product.rating" [cancel]="false"></p-rating></td> -->
              <!-- <td><span [class]="'product-badge status-' + product.inventoryStatus.toLowerCase()">{{product.inventoryStatus}}</span></td> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-recorrido>
            <tr class="historial-nested-table position-relative">
              <td
                [attr.colspan]="recorrido.kilometrajeTotal != '-' ? 7 : 7"
                class="py-0"
              >
                <!-- <td [attr.colspan]="fieldsChanged.fieldName == 'Comments' ? '2' : ''">                                {{fieldsChanged.newValue}}</td> -->

                <div class="panel-izq-table-container2 p-4">
                  <p-table [value]="recorrido.tramas" dataKey="id" [rowHover]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <!-- <th >Id </th> -->
                        <th style="width: 9%"></th>
                        <th style="width: 28%">Fecha y Hora</th>

                        <th class="text-center" style="width: 12%">Comb.</th>
                        <th class="text-center" style="width: 12%">Km.</th>
                        <!-- <th class="text-center" style="width: 25%" *ngIf="recorrido.kilometrajeTotal != '-'" >Kilometraje </th> -->

                        <th class="text-center" style="width: 20%">Duración</th>
                        <!-- <th class="text-center" style="width: 8%"> </th> -->
                        <!-- <th >Status <p-sortIcon field="status"></p-sortIcon></th> -->
                        <!-- <th style="width: 4rem"></th> -->
                      </tr>
                    </ng-template>
                    <ng-template
                      pTemplate="body"
                      let-trama
                      let-rowIndex="rowIndex"
                    >
                      <tr (click)="clickLocate(trama, recorrido.key)">
                        <!-- <td class="text-center">
                                        <div [title]="trama.tooltip" data-bs-toggle="tooltip" data-bs-placement="top" >
                                          <img class="icon-car" [src]="trama.icono" [style.height]="trama.icono_height" [style.width]="trama.icono_width"  />
                                        </div>
                                      </td> -->

                        <!-- <td>{{rowIndex}}</td> -->

                        <!-- <td>{{trama.dt_tracker}}</td>  -->

                        <td class="text-center">
                          <div
                            [title]="trama.tooltip"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                          >
                            <img
                              class="icon-car"
                              [src]="trama.icono"
                              [style.height]="trama.icono_height"
                              [style.width]="trama.icono_width"
                            />
                          </div>
                        </td>

                        <td>{{ trama.trama.dt_tracker }}</td>

                        <td
                          *ngIf="trama.tooltip == 'Movimiento'"
                          class="text-center"
                        >
                          {{ trama.trama.combustible_movimiento }}
                        </td>
                        <td
                          *ngIf="trama.tooltip != 'Movimiento'"
                          class="text-center"
                        >
                          -
                        </td>

                        <td
                          *ngIf="trama.tooltip == 'Movimiento'"
                          class="text-center"
                        >
                          {{ trama.trama.distancia_movimiento }}
                        </td>
                        <td
                          *ngIf="trama.tooltip != 'Movimiento'"
                          class="text-center"
                        >
                          -
                        </td>

                        <td *ngIf="rowIndex == 0" class="text-center">x</td>
                        <td
                          *ngIf="
                            rowIndex != 0 &&
                            rowIndex != recorrido.tramas.length - 1
                          "
                          class="text-center"
                        >
                          {{ trama.trama.temp }}
                        </td>
                        <td
                          *ngIf="
                            rowIndex != 0 &&
                            rowIndex == recorrido.tramas.length - 1
                          "
                          class="text-center"
                        >
                          x
                        </td>

                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="4">
                          Aún no hay órdenes para este producto.
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
